var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1319_56299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3374 18.5873V23.625H14.6628V18.5873C14.6628 16.2487 11.8353 15.0775 10.1816 16.7311L0.768879 26.1438C-0.256293 27.169 -0.256293 28.831 0.768879 29.8561L10.1816 39.2688C11.8352 40.9225 14.6628 39.7513 14.6628 37.4126V32.375H41.3374V37.4127C41.3374 39.7514 44.1648 40.9226 45.8186 39.2689L55.2313 29.8562C56.2565 28.8311 56.2565 27.1691 55.2313 26.1439L45.8186 16.7312C44.1649 15.0775 41.3374 16.2487 41.3374 18.5873Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1319_56299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSide);
export default __webpack_public_path__ + "static/media/side.0345ff1378e619d647df1a1c918e0f24.svg";
export { ForwardRef as ReactComponent };